export const transformValueFloattoFormated = (value, casas = 2) => {

    let valor = value.toFixed(casas).toString();
    if (!valor)
        valor = "0";

    valor = valor.replace(".", ",");

    return valor;
}